import { ABServiceClientV2 } from '@zocdoc/ab';

const optimizelyProjectId = '8426652696';
const abServiceHost =
    process.env.INTERNAL_AWS_API_HOST || process.env.AWS_API_HOST || '';
let abClient;

export function getAbClient() {
    if (!abClient) {
        abClient = new ABServiceClientV2({
            projectId: optimizelyProjectId,
            fetch,
            basePath: abServiceHost,
        });
    }

    return abClient;
}
